module.exports = __webpack_public_path__ + "static/img/exitoso.300e752e.png";